import { useIntl } from 'react-intl';

import { AutoDismissFlag } from '@atlaskit/flag';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import { token } from '@atlaskit/tokens';

import { ComponentFlagId, HandleDismissedType } from 'src/redux/flags/types';

import { messages } from './pull-request-retarget.i18n';

type Props = {
  id: ComponentFlagId;
  props: {
    branchName: string;
  };
} & HandleDismissedType;

export const PullRequestRetargetSuccessFlag = ({
  id,
  props,
  ...otherProps
}: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <AutoDismissFlag
      {...otherProps}
      id={id}
      description={intl.formatMessage(messages.retargetPullRequestSuccessBody, {
        branch: props?.branchName,
      })}
      icon={
        <CheckCircleIcon
          spacing="spacious"
          color={token('color.icon.success')}
          label="success"
        />
      }
      title={intl.formatMessage(messages.retargetPullRequestSuccessTitle)}
    />
  );
};
